import Vue from "vue";

const transformer = ({ supplies = [] }) => ({
  supplies: supplies.length
    ? supplies.map((s) => {
        return { id: s.id, entryReal: +s.realReceivedAmount || +s.receivedQuantity };
      }).filter(({entryReal}) => entryReal > 0)
    : [],
});

export default (purchaseOrderFolio, payload) => {
  return Vue.$http
    .put(`/iwarehouse/update_entry/${purchaseOrderFolio}/`, transformer(payload))
    .then((response) => response.data);
};



// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/sendPurchaseOrderEntries.js